import { createAction, createSlice } from '@reduxjs/toolkit';

// select/deselect action/section
export const selectEditingOption = createAction('screenshotEditing/selectOption', (option) => {
  return {
    payload: option
  };
});

export const editedScreenshot = createAction('screenshotEditing/unsavedChanges', (isEdited) => {
  return {
    payload: isEdited
  };
});

const INITIAL_STATE = {
  editingOption: undefined,
  isLoading: false,
  isError: false,
  isEdited: false
};

const tagSlice = createSlice({
  name: 'screenshotEditing',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(selectEditingOption, (state, action) => {
        state.editingOption = action.payload;
      })
      .addCase(editedScreenshot, (state, action) => {
        state.isEdited = action.payload;
      })
      .addCase('signOutGlobally', (state) => ({ ...INITIAL_STATE }));
  }
});

export default tagSlice.reducer;
